import { useEffect, useState } from 'react';

/**
 * `value`, once it has stopped changing for `ms`. A search box drives a
 * request through this so typing a name sends one request, not one per key.
 */
export function useDebouncedValue<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
